import { Reset } from '../components/Thankyou/Reset';
import React from 'react';
import { Layout } from '../layout/Layout';
import ReactDOM from 'react-dom';

export default function Privatelabel() {
  return (
      <Layout>
        <Reset />
      </Layout>
  );
}



